import { GetFieldLabelFromName } from "@/Utils/DataLib";
import { enumObjClassNames } from "@coreapp/constants";
import ActionListItem from "../../Composites/ActionListItem/ActionListItem";

/**
 * Build field options for plan fields modal accordion list items
 * @param {string[]} fieldsList
 * @param {boolean} isPositionPlan
 * @param {"holder" | "position"} fieldType
 * @param {Record<string, string>} localizationMap
 * @param {(fieldName: string) => Record<string, any>} optionPropsCallback
 * @returns
 */
export const BuildFieldOptions = (
  fieldsList,
  isPositionPlan,
  fieldType = "holder",
  localizationMap = {},
  optionPropsCallback = fieldName => ({})
) => {
  const objClassName =
    fieldType === "position" ? enumObjClassNames.position : enumObjClassNames.box;
  return fieldsList.map(fieldName => {
    const fieldLabel = GetFieldLabelFromName(fieldName, objClassName);
    const label = localizationMap[fieldName] ?? fieldLabel ?? fieldName;
    return {
      content: (
        <ActionListItem
          label={label}
          labelProps={{
            size: "small"
          }}
          flexProps={
            isPositionPlan
              ? {
                  padding: "4px 4px 4px 24px"
                }
              : {}
          }
          spaceBetween={false}
          //   actions={
          //     hasActions
          //       ? [
          //           {
          //             iconName: "trash-can",
          //             iconProps: { color: "error", size: "xsmall" },
          //             onClick: () => DeleteField(fieldName, fieldType)
          //           }
          //         ]
          //       : []
          //   }
          {...optionPropsCallback(fieldName)}
        />
      ),
      value: fieldName,
      padding: isPositionPlan ? false : undefined
    };
  });
};
